import React from "react";

import svg from "../../assets/images/icons/consent.svg";

export const ConsentIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Constant"}
    />
);
